import { Instance } from 'mobx-state-tree';
import { RevokeUserInviteResponseModelBase } from './RevokeUserInviteResponseModel.base';

/* The TypeScript type of an instance of RevokeUserInviteResponseModel */
export interface RevokeUserInviteResponseModelType extends Instance<typeof RevokeUserInviteResponseModel.Type> {}

/* A graphql query fragment builders for RevokeUserInviteResponseModel */
export { selectFromRevokeUserInviteResponse, revokeUserInviteResponseModelPrimitives, RevokeUserInviteResponseModelSelector } from './RevokeUserInviteResponseModel.base';

/**
 * RevokeUserInviteResponseModel
 */
export const RevokeUserInviteResponseModel = RevokeUserInviteResponseModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
